import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import SuiVue from 'semantic-ui-vue';

createApp(App)
    .use(SuiVue)
    .use(router).mount('#app')
